import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReportingService } from '../reporting-service.service';
import { EngagementActivityVm } from 'app/Models/EngagementActivity';
import { ReportMainData } from 'app/ReportingModel/ReportFiltering';
@Component({
    selector: 'app-adoption-report',
    templateUrl: './adoption-report.component.html',
    styleUrls: ['./adoption-report.component.scss']
})
export class AdoptionReportComponent implements OnInit {
    @Input() ReportMainData: ReportMainData;
    constructor(private spinner: NgxSpinnerService, private reportService: ReportingService) { }
    ngOnInit(): void {
        this.spinner.show();
        this.spinner.hide();

        // this.reportService.navigateToReportparent$.subscribe(() => {
        //     this.onScroll.emit();
        // });
    }

    
}